import styled from 'styled-components'

import { up } from '@Globals/Style/breakpoints'

export const ShippingWrapper = styled.div(() => `
  max-width: 100%;
  width: 640px;
  margin: 30px auto;
  font-size: 13px;
  padding: 0 10px;
  position: relative;
`)

export const ShippingDescription = styled.div(() => `
  margin: 24px 0;
  text-align: center;
`)

export const ShippingOptions = styled.div(() => `
  width: 100%;
`)

export const ShippingThresholdPrice = styled.div(({ theme }) => `
  background: ${theme.colors.greyLightest};
  text-align: center;
  display: flex;
  align-items: center; 
  justify-content: center;
`)

export const ShippingOption = styled.div(({ theme }) => `
  display: grid;
  grid-template-columns: 1fr 2fr 1fr 80px;
  border-bottom: 1px solid ${theme.colors.greyLighterer};

  &:first-child {
    ${ShippingThresholdPrice} {
      border-radius: 4px 4px 0 0;
      overflow: hidden;
    }
  }

  &:last-child {
    border-bottom: none;

    ${ShippingThresholdPrice} {
      border-radius: 0 0 4px 4px;
      overflow: hidden;
    }
  }

  ${up('tablet')} {
    grid-template-columns: 1fr 2fr 1fr 150px;
  }
`)

export const ShippingLogo = styled.img(() => `
  height: 100%;
  width: 100%;
  object-fit: contain;
`)

export const ShippingLogoWrapper = styled.div(() => `
  flex: 0 0 70px;
  margin-right: 15px;
  width: 70px;
  height: 65px;
  padding: 15px 0;
`)

export const ShippingInfo = styled.div(() => `
  text-align: center;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 10px 0;
`)

export const ShippingDeliveryTime = styled.div(() => `
  font-weight: 700;
`)

export const ShippingThreshold = styled.div(() => `
  text-align: center;
  width: 80px;
  margin-left: auto;
  padding: 0 4px;
  margin-bottom: 8px;

  ${up('tablet')} {
    width: 150px;
    padding: 0 37px;
  }
`)
